module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showgrid),
      expression: "showgrid"
    }]
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-show": "$ctrl.isNewAvaiable()"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "tooltip": "Adiciona um público alvo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showgrid = !_vm.showgrid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova equipe")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "remunerated",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value ? 'Sim' : 'Não'))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.exclui(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1)])])]), _vm._v(" "), (!_vm.showgrid) ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "ng-disable": "!$ctrl.show.form",
      "ng-form": "frmAddProjectTeam",
      "ssm-isolated-form": ""
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('quantidade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "quantity"
    }
  }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.quantity),
      expression: "equipe.quantity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "quantidade",
      "type": "number",
      "min": "1",
      "max": "2147483647"
    },
    domProps: {
      "value": (_vm.equipe.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cargo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Cargo no projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.role),
      expression: "equipe.role"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cargo",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.equipe.role)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "role", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('cargo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cargo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('perfil profissional pretendido')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "desiredProfile"
    }
  }, [_vm._v("Perfil profissional pretendido:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.desiredProfile),
      expression: "equipe.desiredProfile"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "perfil profissional pretendido",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.equipe.desiredProfile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "desiredProfile", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('perfil profissional pretendido')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('perfil profissional pretendido')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('forma de contratação')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "hiringMethod"
    }
  }, [_vm._v("Forma de contratação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.hiringMethod),
      expression: "equipe.hiringMethod"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "forma de contratação"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.equipe, "hiringMethod", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.formasContratacao), function(forma) {
    return _c('option', {
      domProps: {
        "value": forma.name
      }
    }, [_vm._v(_vm._s(forma.description))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('forma de contratação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma de contratação')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('carga horaria')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "workload"
    }
  }, [_vm._v("Carga horária semanal:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.workload),
      expression: "equipe.workload"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "carga horaria",
      "type": "number",
      "min": "1",
      "max": "2147483647"
    },
    domProps: {
      "value": (_vm.equipe.workload)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "workload", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Horas")])]), _vm._v(" "), (_vm.errors.first('carga horaria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('carga horaria')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('remunerado pelo projeto')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "remunerated"
    }
  }, [_vm._v("É remunerado pelo projeto?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.remunerated),
      expression: "equipe.remunerated"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "remunerado pelo projeto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.equipe, "remunerated", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('remunerado pelo projeto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('remunerado pelo projeto')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Resudo das atividades')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "activityResume"
    }
  }, [_vm._v("Resumo das atividades:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "$ctrl.approval",
      "state": "$ctrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.equipe.activityResume),
      expression: "equipe.activityResume"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Resudo das atividades",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.equipe.activityResume)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.equipe, "activityResume", $event.target.value)
      }
    }
  }, [_vm._v("              " + _vm._s(_vm.equipe.activityResume) + "\n            ")])]), _vm._v(" "), (_vm.errors.first('Resudo das atividades')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resudo das atividades')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-team-add"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-team-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-449ea82e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/equipeProjetoOld.vue
// module id = 1931
// module chunks = 1